export const TransactionType = {
    SPEND: "SPEND",
    RECIEVED: "RECIEVED",
}

export const DocumentType = {
    TAX_DOCUMENT: 'TAX_DOCUMENT',
    PAYMENT: 'PAYMENT',
    MANUAL: 'MANUAL',
    CREDIT: 'CREDIT',
    RENDITION: 'RENDITION',
    OBLIGATION: 'OBLIGATION',
}

export const EERR_DEFAULT = {
    SALE: 'ventassinclasificar',
    EXPENSE: 'comprassinclasificar',
    BOLETA: 'ventasporboleta',
    FEES: 'honorariosprofesionales',
    FINANCE: 'intereses',
    IVA: 'ivanorecuperable',
}

export const EERR_CATEGORY_DEFAULT = {
    SALE: 'ventastotales',
    EXPENSE: 'comprastotales',
}

export const NominaStatus = {
    CREATED: 'CREATED',
    DELETED: 'DELETED',
    INFORMED: 'INFORMED',
    BANKLOADED: 'BANKLOADED',
    PAID: 'PAID',
    MANUAL: 'MANUAL',
    REJECTED: 'REJECTED',
    PROCESSED: 'PROCESSED',
    SMARTCFO_INFORM: 'SMARTCFO_INFORM',
    SMARTCFO_INFORMED: 'SMARTCFO_INFORMED',
}

export const NominaProcessStatus = {
    SELECTED: 'SELECTED',
    IN_CREATED_NOMINA: 'IN_CREATED_NOMINA',
    IN_INFORMED_NOMINA: 'IN_INFORMED_NOMINA',
    IN_BANK_NOMINA: 'IN_BANK_NOMINA',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
}

export const FLOW_TRANSLATE = {
    INCOME: "Ingresos",
    EXPENSE: "Egresos",
    RESUME: 'Resumen',
    TOTAL: 'Total',
}

export const EOAF_DEFAULT = {
    RECIEVED :'ingresossinclasificar',
    SPEND :'egresossinclasificar',
}

export const EOAF_TRANSLATE = {
    RECIEVED :'Ingresos',
    SPEND :'Egresos',
}
